import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { testimonials, fadeUp, stagger } from "@/data/landingData";

export default function Testimonials() {
  return (
    <section
      className="py-24 lg:py-32 section-dark relative overflow-hidden"
      data-testid="testimonials"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url(https://static.prod-images.emergentagent.com/jobs/e3dd95cb-332c-4595-a6d9-da61903a36a5/images/1fedbcc5aa622c7473a2d0e1584ad28b77e9c191843994c2c3967df860d30c64.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="text-center mb-16"
        >
          <motion.span
            variants={fadeUp}
            className="mono text-xs text-[#00E5FF] uppercase tracking-[0.2em]"
          >
            Referencie
          </motion.span>
          <motion.h2
            variants={fadeUp}
            className="text-4xl sm:text-5xl font-black tracking-tight mt-4"
          >
            Spokojní <span className="text-[#FF5E00]">klienti</span>
          </motion.h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="glass-card p-8 relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={32} className="text-[#00E5FF]/20 absolute top-6 right-6" />
              <p className="text-zinc-300 leading-relaxed mb-6">"{item.text}"</p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#00E5FF] to-[#FF5E00] flex items-center justify-center font-bold">
                  {item.avatar}
                </div>
                <div>
                  <p className="font-bold">{item.author}</p>
                  <p className="text-zinc-500 text-sm">{item.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
